import {ChangeDetectionStrategy, Component, Input} from "@angular/core";

@Component({
  standalone: false,
  selector: 'app-customer-link',
  templateUrl: './customer-link.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomerLinkComponent {

  @Input() customer: any;
  @Input() address: any;
  @Input() phone: string;
  @Input() additionalPhone: string;


  constructor() {
  }

}
